<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="chapter-3">
<h1>Chapter 3</h1>
<p>‘I’m going to the canteen. Anyone want anything?’ Sophie asked.</p>
<p>‘Nope, all good.’</p>
<p>‘Wait for me,’ she called as Crystal, Ash and I stood on the steps at the side of the queue. It offered a clear view of students hustling and waiting impatiently in line to be served.</p>
<p>‘Just look at that boy,’ sighed Crystal.</p>
<p>‘What Steve?’ I asked, ‘I thought you couldn’t stand him?’</p>
<p>‘I can’t! He doesn’t fool me, not one little bit. No, I’m referring to Jake.’</p>
<p>‘Seriously?’ I was taken aback.</p>
<p>‘There’s something about him…’</p>
<p>‘That he looks like a bird of prey?’ I joked.</p>
<p>Crystal whacked my arm. ‘Really? I don’t see that. I was talking to him after math and he was actually nice when he’s not with Steve.’</p>
<p>‘If you say so; he’s F-ing annoying in my opinion.’</p>
<p>‘He asked if you were going out with anyone, Jess,’ she said, whacking my arm again, ‘I think he’s got the hots for you!’</p>
<p>‘<em>No</em> thank you!’ I whacked her back, ‘He’s all yours!’</p>
<p>Ashleigh was listening to our banter. ‘No, Steve’s the one. He’s made in the image of perfection, a total babe.’ Her voice cooed like a pigeon. ‘I think about him in class, at home, in my dreams…’</p>
<p>‘No way!’</p>
<p>‘You’d make a cute couple,’ Crystal admitted. ‘Looks wise.’</p>
<p>‘What you talking about?’ Sophie appeared by our side and handed us each a protein ball.</p>
<p>‘Thanks, Soph! Ash has flashed her eyes at Steve,’ Crystal responded.</p>
<p>‘Girlfriend, stay clear of him,’ Soph warned, ‘Guys like that will charm the pants off a giraffe to get what they want. I don’t want to see you hurt.’</p>
<p>We thought Ash was smart. It was embarrassing to watch her melt like ice-cream on a hot day when he walked by and whistled; or blew her a kiss or something equally wicked across the classroom. We started to see less of her at lunch and they’d sit together in class giggling. Word soon got round they were tight.</p>
<p>It really bothered Crystal, Sophie and I that Ash was swept into Steve’s hypnotic aura, hook, line and sinker.</p>
<p>‘I can see why it’s tempting to be attracted to a guy who’s charming and good-looking but Steve doesn’t care.’</p>
<p>‘Ashleigh will be just another fling he can boast about.’</p>
<p>Crystal was blunt, ‘She’s probably giving out.’</p>
<p>‘Don’t say things like that! I don’t want that image burned in my brain.’</p>
<p>We all saw through Steve’s phoney charisma. How could Ashleigh not?</p><br/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch007.vue?e9f8c650